import Cookies from 'js-cookie';
import { checkForDomain } from '.';

export const verifyToken = (err) => {
    const currentIP = window.location.host;
    if (err.response.status == 401) {
        Cookies.remove('X-ADMIN-JWT', { path: '/' });
        Cookies.remove('X-ADMIN-JWT', { domain: checkForDomain() });
        Cookies.remove('X-ADMIN-ID', { path: '/' });
        Cookies.remove('X-ADMIN-ID', { domain: checkForDomain() });
        Cookies.remove('name', { path: '/' });
        Cookies.remove('user_id', { path: '/' });
        Cookies.remove('startup_id', { path: '/' });
        Cookies.remove('email', { path: '/' });
        Cookies.remove('is_profile_complete', { path: '/' });
        Cookies.remove('startup_id', { path: '/' });
        Cookies.remove('step', { path: '/' });
        Cookies.remove('ur', { path: '/' });
        Cookies.remove('search_startups', { path: '/' });
        Cookies.remove('search_backrr_startups', { path: '/' });
        Cookies.remove('backrr_startups_query', { path: '/' });
        Cookies.remove('backrr_startups_status', { path: '/' });
        // Cookies.remove('deal-index', { path: '/' });
        // Cookies.remove('investor-index', { path: '/' });
        // Cookies.remove('master-index', { path: '/' });
        // Cookies.remove('user_id', { path: '/' });
        // Cookies.remove('slug', { path: '/' });
        // Cookies.remove('profile_image', { path: '/' });
        // Cookies.remove('user_role', { path: '/' });
        // localStorage.removeItem('permission');
        // Cookies.remove('permission_id',{ path: '/' });
        // Cookies.remove('syndicate_id',{ path: '/' });
        window.location.href = '/login';
    }
};

export const RetryOnError = (failureCount, error) => (error.response.status != 401 && failureCount < 2 ? true : false);
